const perfil = {
    ANALISTA: 1,
    CLIENTE: 2,
    SERVICO: 3,
    ADMINISTRADOR: 4,
    COMERCIAL: 5,
    COMERCIAL_PARCEIRO: 6,
    PLATAFORMA: 7,
    CORRETOR_PARCEIRO: 8,

    perfilList: function(exibirCliente) {
      if (exibirCliente) {
        return [
          {
            id: 1,
            descricao: 'Analista'
          },
          {
            id: 2,
            descricao: 'Cliente'
          },
          {
            id: 4,
            descricao: 'Administrador'
          },
          {
            id: 5,
            descricao: 'Comercial'
          },
          {
            id: 6,
            descricao: 'Comercial Parceiro'
          },
          {
            id: 7,
            descricao: 'Plataforma'
          },
          {
            id: 8,
            descricao: 'Corretor Parceiro'
          }
        ]
      } else {
        return [
          {
            id: 1,
            descricao: 'Analista'
          },
          {
            id: 4,
            descricao: 'Administrador'
          },
          {
            id: 5,
            descricao: 'Comercial'
          },
          {
            id: 6,
            descricao: 'Comercial Parceiro'
          },
          {
            id: 7,
            descricao: 'Plataforma'
          },
          {
            id: 8,
            descricao: 'Corretor Parceiro'
          }
        ]
      }
    },

    filterList: [
      {
        id: 99,
        descricao: 'Todos os Perfis'
      },
      {
        id: 1,
        descricao: 'Analista'
      },
      {
        id: 2,
        descricao: 'Cliente'
      },
      {
        id: 4,
        descricao: 'Administrador'
      },
      {
        id: 5,
        descricao: 'Comercial'
      },
      {
        id: 6,
        descricao: 'Comercial Parceiro'
      },
      {
        id: 7,
        descricao: 'Plataforma'
      },
      {
        id: 8,
        descricao: 'Corretor Parceiro'
      }
    ],

    isCliente: function (idPerfil) {
        return idPerfil == 2;
    },
    isAnalista: function (idPerfil) {
        return idPerfil == 1;
    },
    isAdmin: function (idPerfil) {
      return idPerfil == 4;
    },
    isComercial: function (idPerfil) {
      return idPerfil == 5;
    },
    isComercialParceiro: function(idPerfil) {
      return idPerfil == 6;
    },
    isPlataforma: function(idPerfil) {
      return idPerfil == 7;
    },
    isCorretorParceiro: function(idPerfil) {
      return idPerfil == 8;
    }
}

export default perfil;


// WEBPACK FOOTER //
// ./src/helpers/perfil.js